/**
 * Simple localStorage cache with TTL and schema version busting.
 */
export function localCacheGet(key, { ttlMs, version } = {}) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    const { ts, version: storedVersion, data } = parsed;
    if (version != null && storedVersion !== version) return null;
    if (ttlMs && (!ts || Date.now() - ts > ttlMs)) return null;
    return data;
  } catch {
    return null;
  }
}

export function localCacheSet(key, data, { version } = {}) {
  try {
    localStorage.setItem(key, JSON.stringify({
      ts: Date.now(),
      version: version ?? null,
      data,
    }));
  } catch {
    // ignore quota errors
  }
}
